export class MoveColumnComponentCommand {
  public SiteId: string = "";
  public ComponentId: number = 0;
  public ColIndex: number = 0;
}